export default __webpack_public_path__ + "static/box-6e8c8f74444f34d7e487424acfca812d.png";